import { Link, useLocation } from "react-router-dom";
import { ScanLine } from "lucide-react";

export default function MobileScanBar() {
  const { pathname } = useLocation();
  if (/^\/(free-scan|checkout|results|score|thank-you)/.test(pathname)) return null;
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-slate-200 px-4 py-3 pr-24" data-testid="mobile-scan-bar">
      <Link to="/free-scan" className="flex items-center justify-center gap-2 h-11 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold text-sm" data-testid="mobile-scan-bar-btn">
        <ScanLine className="h-4 w-4" /> Free AI Readiness Score
      </Link>
    </div>
  );
}
